/**
 * Created by Mark on 19/04/2017.
 */



import React  from 'react';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Button from 'react-bootstrap/lib/Button';

export default class BulkStaffImport extends React.Component{

    render(){

        const popoverBottom = (
            <Popover id="popover-positioned-bottom" title="Popover bottom">
                <strong>Holy guacamole!</strong> Check this info.
            </Popover>
        );

        return <OverlayTrigger trigger="click" placement="left" overlay={popoverBottom}>
                    <Button>Holy guacamole!</Button>
               </OverlayTrigger>
    }
}


// WEBPACK FOOTER //
// ./src/components/forms/teacher-bulk-import.js